import { useState } from 'react'
import { initApp } from './lib/telegram'
import { getTelegramLang, translate } from './lib/i18n'
import { useForecast } from './hooks/useForecast'
import { Header } from './components/Header'
import { StatsRow } from './components/StatsRow'
import { Banner } from './components/Banner'
import { ForecastList } from './components/ForecastList'
import { ProgressBar } from './components/ProgressBar'
import { NoDataScreen } from './components/NoDataScreen'
import { WeightChart } from './components/WeightChart'
import { DevSwitcher } from './components/DevSwitcher'
import type { MockKey } from './lib/mockData'

initApp()

const IS_DEV = import.meta.env.DEV

function getInitialMock(): MockKey {
  const param = new URLSearchParams(window.location.search).get('mock')
  if (param && ['no_data', 'warmup', 'active_high', 'active_medium', 'active_low', 'plateau'].includes(param)) {
    return param as MockKey
  }
  return 'active_high'
}


export default function App() {
  const [mockKey, setMockKey] = useState<MockKey>(() => IS_DEV ? getInitialMock() : 'active_high')
  const { data, loading, error, retry } = useForecast(IS_DEV ? mockKey : undefined)

  const tgLang = getTelegramLang()

  if (loading) {
    return <div style={styles.center}><p>{translate('app.loading', tgLang)}</p></div>
  }

  if (error) {
    return (
      <div style={styles.center}>
        <button onClick={retry} style={styles.retryBtn}>
          {translate('error.retry', tgLang)}
        </button>
      </div>
    )
  }

  const noData = !data || 'status' in data

  return (
    <>
<div style={{ ...styles.root, paddingBottom: IS_DEV ? 64 : 32 }}>
        {noData ? (
          <NoDataScreen />
        ) : (
          <>
            <Header state={data.state} />
            <WeightChart state={data.state} chart={data.chart} />
            <StatsRow state={data.state} chart={data.chart} />
            <Banner state={data.state} />
            <ForecastList state={data.state} />
            <ProgressBar state={data.state} />
          </>
        )}
      </div>
      {IS_DEV && <DevSwitcher current={mockKey} onChange={setMockKey} />}
    </>
  )
}

const styles: Record<string, React.CSSProperties> = {
  root: {
    padding: '0 16px',
    fontFamily: 'system-ui, sans-serif',
    minHeight: '100vh',
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    fontFamily: 'system-ui, sans-serif',
  },
  retryBtn: {
    padding: '12px 24px',
    fontSize: 16,
    fontFamily: 'system-ui, sans-serif',
    background: 'var(--tg-theme-button-color, #2481cc)',
    color: 'var(--tg-theme-button-text-color, #fff)',
    border: 'none',
    borderRadius: 10,
    cursor: 'pointer',
  },
}
